import {
  TOGGLE_IDENTITY_SELECTION,
  RESET_IDENTITY_SELECTION,
} from '../actions/my-faces-filter';

const initialState = {
  selectedIdentities: [],
};

const myFacesFilterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOGGLE_IDENTITY_SELECTION: {
      if (
        state.selectedIdentities.find(({ id }) => id === action.identity.id)
      ) {
        return {
          ...state,
          selectedIdentities: state.selectedIdentities.filter(
            ({ id }) => id !== action.identity.id,
          ),
        };
      }
      return {
        ...state,
        selectedIdentities: [
          ...state.selectedIdentities,
          { ...action.identity },
        ],
      };
    }

    case RESET_IDENTITY_SELECTION:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export { initialState };
export default myFacesFilterReducer;
